// src/components/charts/EfficiencyChart.jsx
import React, { useMemo } from "react";
import BarChart from "components/charts/BarChart";
import dayjs from "dayjs";

export default function EfficiencyChart({
  salesData,
  metric,
  interval,
  height = 260,
}) {
  const points = useMemo(() => {
    if (!salesData?.predicted_sales) return [];

    return salesData.predicted_sales
      .map((d) => ({
        label: d.label,
        value: d[metric] ?? null,
      }))
      .filter((d) => d.label);
  }, [salesData, metric]);

  const categories = points.map((d) => d.label);
  const values = points.map((d) => d.value);

  const isPercent =
    metric === "gross_margin" || metric.includes("growth");

  const series = [
    {
      name: metric,
      data: values,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      background: "transparent",
      foreColor: "#B6B6B6",
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "60%",
      },
    },
    xaxis: {
      categories,
      labels: {
        formatter: (v) => {
          if (interval === "monthly") return v;
          if (interval === "weekly") return v;
          return dayjs(v).format("MM-DD");
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (v) =>
          v == null
            ? "-"
            : isPercent
            ? `${(v * 100).toFixed(1)}%`
            : `$${Number(v).toFixed(2)}`,
      },
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (v) =>
          isPercent
            ? `${(v * 100).toFixed(1)}%`
            : `$${Number(v).toFixed(2)}`,
      },
    },
    colors: [
      isPercent
        ? "rgba(72, 187, 120, 0.85)"
        : "rgba(250, 204, 21, 0.85)",
    ],
    legend: { show: false },
  };

  if (!categories.length) return null;

  return (
    <div style={{ height }}>
      <BarChart chartData={series} chartOptions={options} />
    </div>
  );
}